export class ExchangeRates {
  id: number;
  eur_to_uah_ask: number;
  eur_to_uah_bid: number;
  eur_to_usd_ask: number;
  eur_to_usd_bid: number;
  usd_to_uah_ask: number;
  usd_to_uah_bid: number;
  usd_to_eur_ask: number;
  usd_to_eur_bid: number;

  setFromApiModel(apiModel: any): this {
    this.id = apiModel.id;
    this.eur_to_uah_ask = apiModel.eur_to_uah_ask;
    this.eur_to_uah_bid = apiModel.eur_to_uah_bid;
    this.eur_to_usd_ask = apiModel.eur_to_usd_ask;
    this.eur_to_usd_bid = apiModel.eur_to_usd_bid;
    this.usd_to_uah_ask = apiModel.usd_to_uah_ask;
    this.usd_to_uah_bid = apiModel.usd_to_uah_bid;
    this.usd_to_eur_ask = apiModel.usd_to_eur_ask;
    this.usd_to_eur_bid = apiModel.usd_to_eur_bid;
    return this;
  }
}



